import { gql } from "@apollo/client";

export const getTargetForIndividualSkillScore = gql`
  query getTarget($id: ID!) {
    getTarget(id: $id) {
      id
      title
      type
      description
      targetTag
      createdByUserId
      startDate
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      linkTarget {
        id
        title
        description
        type
        unsplashImage {
          url
          fileName
        }
        logo {
          url
          fileName
        }
      }
      logo {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      unsplashImage {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      dueDate
      weightage
      targetAttachmentLinks
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      targetStatus
      createdAt
      updatedAt
    }
  }
`;

export const getTarget = gql`
  query getTarget($id: ID!) {
    getTarget(id: $id) {
      id
      companyId
      comment
      isNew
      title
      type
      description
      reviewStatus
      targetTag
      createdByUserId
      performanceRating
      startDate
      isCreatorOptOut
      completionApprovalRequired
      userTargetStatusOfLoginUser {
        id
        status
        enableMarkCompletionRequest
        selfRating
        leadReviewerRating
      }
      primaryCoach {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
      }
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      linkTarget {
        id
        title
        description
        type
        createdByUserId
        createdBy {
          firstName
          lastName
          profileImage {
            url
            fileName
          }
        }
        unsplashImage {
          url
          fileName
        }
        logo {
          url
          fileName
        }
      }
      strengths {
        color
        createdAt
        description
        id
        name
        updatedAt
      }
      logo {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      unsplashImage {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      dueDate
      weightage
      isTemplate
      targetAttachmentLinks
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      targetUser {
        items {
          id
          targetid
          userid
          enableMarkCompletionRequest
          userTargetStatus
          isDeletedCompletionApprovalComment
          completionApprovalStatus
          completionRequestComment
          ratingByCoachee
          user {
            id
            eeid
            firstName
            lastName
            fullName
            designation
            totalWeightage
            location
            role
            department
            profileImage {
              url
              fileName
            }
            status
          }
          userTargetDetails {
            totalAssignedObjectives
            completedObjectives
            totalAssignedCheckins
            completedCheckins
            status
          }
          strengths {
            color
            createdAt
            description
            id
            name
            updatedAt
          }
          isSelected
          createdAt
          updatedAt
        }
      }
      coachTarget {
        items {
          id
          targetid
          coachid
          appointedAsCreator
          coach {
            id
            eeid
            firstName
            lastName
            role
            department
            designation
            totalWeightage
            fullName
            status
            profileImage {
              url
              fileName
            }
          }
          isSelected
          createdAt
          updatedAt
        }
      }
      targetObjective {
        items {
          id
          name
          isDeleted
          objectiveSequenceNo
          completionRequired
          status
          objectiveTargetDetails {
            totalAssignedCoachees
            status
            totalCompletedCoachees
          }
          objectiveUser {
            items {
              id
              targetobjectiveid
              userid
              comment
              status
              subStatus
              isSelected
              user {
                id
                eeid
                role
                department
                designation
                firstName
                fullName
                lastName
                department
                status
                profileImage {
                  url
                  fileName
                }
              }
            }
          }
        }
      }
      targetStatus
      activeStep
      lastAction
      currentAction
      publishDate
      createdBy {
        firstName
        fullName
        totalWeightage
        id
        lastName
        department
        designation
        location
        profileImage {
          url
          fileName
        }
        role
        createdAt
        status
        totalWeightage
        profile {
          contactNumber
          email
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const getTargetCheckinDetail = gql`
  query getTargetCheckinDetail(
    $id: ID!
    $userId: ID
    $checkinListType: CheckinListType
    $checkinSelection: TargetFilterType
  ) {
    getTarget(id: $id) {
      targetStatus
      listCheckinCustom(
        targetId: $id
        checkinListType: $checkinListType
        checkinSelection: $checkinSelection
      ) {
        items {
          checkins {
            id
            isNew
            enableViewResponse
            userRoleTypeForSRS
            usersForCheckin {
              items {
                assignedAsIndividual
                assignedViaDepartment
                assignedViaUserGroup
                checkinId
                id
                userId
                user {
                  firstName
                  lastName
                  profileImage {
                    url
                    fileName
                  }
                }
              }
            }

            checkinStatusToDisplay
            combinedCheckInTypes
            name
            checkInType
            description
            scheduleFrequency
            frequencyRepeatsOn
            startDate
            endDate
            isCheckinLibrary
            checkInStatus
            isCommentResponse
            isUploadResponse
            checkinActivationDaysAfterReview
            publishPeriod
            checkInTargetId
            notifyCoachee
            isDeleted
            createdByUserId
            createdBy {
              profileImage {
                url
                fileName
              }
              firstName
              lastName
              fullName
              department
            }
            companyId
            skills {
              definitions {
                definition
                frequency
              }
              name
            }
            checkinFrequencyDates {
              sequenceNo
              startDate
            }
            checkinCoach {
              profileImage {
                url
                fileName
              }
              firstName
              lastName
              fullName
            }
            checkinDetails {
              totalAssignedCoachees
              status
              startDate
              endDate
              isCurrentFrequency
              totalCompletedCoachees
              checkinSequenceNo
            }
            userCheckinDetails(userId: $userId) {
              endDate
              isCurrentFrequency
              startDate
              status
              id
              checkinSequenceNo
              ratees {
                status
                ratee {
                  userid
                  firstName
                  lastName
                  profileImage {
                    url
                    fileName
                  }
                }
              }
            }
            createdBy {
              profileImage {
                url
                fileName
              }
              firstName
              lastName
              fullName
              department
            }
            allCheckinRatees {
              firstName
              lastName
              userid
              profileImage {
                url
                key
                fileName
              }
            }
            allCheckinRaters {
              lastName
              firstName
              userid
              profileImage {
                key
                fileName
                url
              }
            }
            allCheckinViewers {
              lastName
              firstName
              userid
              profileImage {
                key
                fileName
                url
              }
            }
            checkinCoachId
            checkinCoach {
              profileImage {
                url
                fileName
              }
              id
              firstName
              lastName
              fullName
            }
            eventCheckin {
              details
              documents {
                bucket
                fileName
                key
                region
                uploadUrl
                url
              }
              eventType
              location
              url
              eventTime
              eventDate
            }
            linkCheckin {
              link
              title
              description
              image
            }
            multimediaCheckin {
              fileType
              s3Link {
                bucket
                fileName
                key
                region
                uploadUrl
                url
              }
              isVideoUrl
            }
            surveyCheckin {
              isanonymous
              score
              surveycheckin {
                answer
                options
                question
                questionType
                userAnswer
              }
            }
            textCheckin {
              description
            }
          }
          type
        }
      }
    }
  }
`;

/* export const getTargetDetailsForTargetSkillScore = gql`
  query getTargetDetails($id: ID!) {
    getTarget(id: $id) {
      id
      title
      type
      description
      targetTag
      createdByUserId
      startDate
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      linkTarget {
        id
        title
        description
        type
        createdByUserId
        createdBy {
          firstName
          fullName
          lastName
          id
          profileImage {
            url
            fileName
          }
        }
        unsplashImage {
          url
          fileName
        }
        logo {
          url
          fileName
        }
      }
      logo {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      unsplashImage {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      dueDate
      weightage
      isTemplate
      targetAttachmentLinks
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      targetStatus
      publishDate
      checkin {
        items {
          id
          isNew
          canUserViewCheckinResponse
          combinedCheckInTypes
          name
          checkInType
          description
          scheduleFrequency
          frequencyRepeatsOn
          startDate
          endDate
          createdAt
          isCheckinLibrary
          checkInStatus
          isCommentResponse
          isUploadResponse
          checkinActivationDaysAfterReview
          publishPeriod
          checkInTargetId
          userRoleTypeForSRS
          allCheckinRaters {
            lastName
            firstName
            userid
            profileImage {
              key
              fileName
              url
            }
          }
          checkinCoachId
          checkinCoach {
            profileImage {
              url
              fileName
            }
            id
            firstName
            lastName
            fullName
          }
          createdBy {
            profileImage {
              url
              fileName
            }
            firstName
            lastName
            fullName
            department
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`; */

export const getDashboardOrangeDot = gql`
  query getDashboardOrangeDot($type: [String], $userId: ID) {
    dashboardDotNotifications(type: $type, userId: $userId) {
      report {
        successStory
        performanceReview
      }
      target {
        coachingTarget
        activeTargets
      }
      __typename
    }
  }
`;

export const getTargetDetails = gql`
  query getTargetDetails($id: ID!) {
    getTarget(id: $id) {
      id
      isNew
      title
      type
      description
      reviewStatus
      targetTag
      createdByUserId
      performanceRating
      startDate
      isCreatorOptOut
      completionApprovalRequired
      userTargetStatusOfLoginUser {
        id
        status
        enableMarkCompletionRequest
        selfRating
        leadReviewerRating
      }
      primaryCoach {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
      }
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      skillsAndStrengths {
        id
        name
        isStrength
        color
        category
      }
      linkTarget {
        id
        title
        description
        type
        createdByUserId
        logo {
          url
          fileName
        }
        createdBy {
          firstName
          fullName
          lastName
          id
          profileImage {
            url
            fileName
          }
        }
        unsplashImage {
          url
          fileName
        }
        logo {
          url
          fileName
        }
      }
      strengths {
        color
        createdAt
        description
        id
        name
        updatedAt
      }
      logo {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      unsplashImage {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      dueDate
      weightage
      isTemplate
      targetAttachmentLinks
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      targetUser {
        items {
          id
          targetid
          userid
          enableMarkCompletionRequest
          userTargetStatus
          user {
            id
            eeid
            firstName
            lastName
            fullName
            designation
            totalWeightage
            location
            role
            department
            profileImage {
              url
              fileName
            }
            status
          }
          userTargetDetails {
            totalAssignedObjectives
            completedObjectives
            totalAssignedCheckins
            completedCheckins
            status
          }
          strengths {
            color
            createdAt
            description
            id
            name
            updatedAt
          }
          isSelected
          createdAt
          updatedAt
        }
      }
      coachTarget {
        items {
          id
          targetid
          coachid
          appointedAsCreator
          coach {
            id
            eeid
            firstName
            lastName
            role
            department
            designation
            totalWeightage
            fullName
            status
            profileImage {
              url
              fileName
            }
          }
          isSelected
          createdAt
          updatedAt
        }
      }
      objectiveTeamview
      targetObjective {
        items {
          id
          name
          isDeleted
          autoEnroll
          objectiveSequenceNo
          completionRequired
          status
          objectiveStatusTrack
          objectiveTargetDetails {
            totalAssignedCoachees
            status
            totalCompletedCoachees
          }
          objectiveUser {
            items {
              id
              targetobjectiveid
              userid
              comment
              status
              subStatus
              isSelected
            }
          }
        }
      }
      targetStatus
      activeStep
      lastAction
      currentAction
      publishDate
      createdBy {
        firstName
        fullName
        totalWeightage
        id
        lastName
        department
        designation
        location
        profileImage {
          url
          fileName
        }
        role
        createdAt
        status
        totalWeightage
        profile {
          contactNumber
          email
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const getTargetCheckin = gql`
  query getTargetCheckin($id: ID!, $userId: ID) {
    getTarget(id: $id) {
      id
      checkin {
        items {
          id
          isNew
          canUserViewCheckinResponse
          combinedCheckInTypes
          name
          assignPeopleGroup {
            assignCoachees
            assignViewers
            primaryCoach
            assignRaters
          }
          checkInType
          description
          scheduleFrequency
          frequencyRepeatsOn
          startDate
          endDate
          updatedAt
          templateEndDateTime
          templateLaunchDay
          daysToComplete
          templateLaunchDateTime
          launchTime
          dueTime
          isImmediate
          createdAt
          isCheckinLibrary
          checkInStatus
          isCommentResponse
          isUploadResponse
          checkinActivationDaysAfterReview
          publishPeriod
          checkInTargetId
          userRoleTypeForSRS
          skills {
            definitions {
              definition
              frequency
            }
            name
          }
          usersForCheckin {
            items {
              assignedAsIndividual
              assignedViaDepartment
              assignedViaUserGroup
              checkinId
              id
              userId
              user {
                firstName
                lastName
                profileImage {
                  url
                  fileName
                }
              }
            }
          }
          #allCheckinRatees {
          #  firstName
          #  lastName
          #  userid
          #  profileImage {
          #    url
          #    fileName
          #    key
          #  }
          #}
          #allCheckinRaters {
          #  lastName
          #  firstName
          #  userid
          #  profileImage {
          #    key
          #    fileName
          #    url
          #  }
          #}
          #allCheckinViewers {
          #  lastName
          #  firstName
          #  userid
          #  profileImage {
          #    key
          #    fileName
          #    url
          #  }
          #}
          checkinDetails {
            totalAssignedCoachees
            status
            startDate
            endDate
            isCurrentFrequency
            totalCompletedCoachees
            checkinSequenceNo
          }
          userCheckinDetails(userId: $userId) {
            endDate
            isCurrentFrequency
            startDate
            status
            id
            checkinSequenceNo
            ratees {
              status
              ratee {
                userid
                firstName
                lastName
                profileImage {
                  url
                  fileName
                }
              }
            }
          }
          checkinFrequencyDates {
            sequenceNo
            startDate
          }
          checkinCoachId
          checkinCoach {
            profileImage {
              url
              fileName
            }
            id
            firstName
            lastName
            fullName
          }
          createdByUserId
          createdBy {
            profileImage {
              url
              fileName
            }
            firstName
            lastName
            fullName
            department
          }
          usercheckin {
            items {
              id
              checkinid
              userid
              checkInStatus
              # updatedAt
              checkInStartDate
              checkInEndDate
              checkinSequenceNo
              checkinCommentLikeUsersID
              #responseDocument {
              #  url
              #  fileName
              #}
              #checkinCommentLikeUsers {
              #  id
              #  firstName
              #  lastName
              #  fullName
              #}
              #surveyCheckin {
              #  isanonymous
              #  score
              #  surveycheckin {
              #    answer
              #    options
              #    question
              #    questionType
              #    userAnswer
              #  }
              #}
              #user {
              #  id
              #  firstName
              #  lastName
              #  profileImage {
              #    url
              #    fileName
              #  }
              #  status
              #}
              usercomment
              checkInStatus
            }
          }
          eventCheckin {
            details
            documents {
              bucket
              fileName
              key
              region
              uploadUrl
              url
            }
            eventType
            location
            url
            eventTime
            eventDate
          }
          linkCheckin {
            link
            title
            description
            image
          }
          multimediaCheckin {
            fileType
            s3Link {
              bucket
              fileName
              key
              region
              uploadUrl
              url
            }
            isVideoUrl
          }
          surveyCheckin {
            isanonymous
            score
            surveycheckin {
              answer
              options
              question
              questionType
              userAnswer
            }
          }
          textCheckin {
            description
          }
        }
      }
    }
  }
`;

export const userCheckinRespond = gql`
  query userCheckinRespond($id: ID!, $filter: ModelUserCheckInFilterInput) {
    getCheckIn(id: $id) {
      usercheckin(filter: $filter) {
        items {
          id
          userid
          usercomment
          usercommentDate
          responseDocumentDate
          responseDocument {
            bucket
            fileName
            isNew
            key
            region
            uploadUrl
            url
          }
        }
      }
    }
  }
`;

export const getTargetBannerInfo = gql`
  query getTargetBannerInfo($id: ID!) {
    getTarget(id: $id) {
      id
      companyId
      isNew
      isTemplate
      title
      type
      description
      reviewStatus
      targetTag
      createdByUserId
      startDate
      completionApprovalRequired
      objectiveTeamview
      targetLevelUserRoleTypeForSRS
      userTargetStatusOfLoginUser {
        id
        status
        enableMarkCompletionRequest
        selfRating
        leadReviewerRating
        completionDate
      }
      primaryCoach {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
        status
      }
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      skillsAndStrengths {
        name
        isStrength
        color
        id
        description
      }
      linkTarget {
        id
        title
        description
        type
        createdByUserId
        dueDate
        targetUser {
          items {
            id
          }
        }
        targetStatus
        createdBy {
          firstName
          lastName
          profileImage {
            url
            fileName
          }
        }
        unsplashImage {
          url
          fileName
        }
        logo {
          url
          fileName
        }
      }
      strengths {
        color
        createdAt
        description
        id
        name
        updatedAt
      }
      logo {
        url
        fileName
      }
      unsplashImage {
        url
        fileName
      }
      targetAttachmentLinks
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      dueDate
      weightage
      targetUser {
        items {
          id
          targetid
          userid
          showAnimation
          user {
            id
            eeid
            firstName
            lastName
            fullName
            designation
            department
            profileImage {
              url
              fileName
            }
            status
            supervisor {
              id
              fullName
              firstName
              lastName
              profileImage {
                fileName
              }
            }
          }
        }
      }
      coachTarget {
        items {
          id
          targetid
          coachid
          appointedAsCreator
          coach {
            id
            eeid
            firstName
            lastName
            role
            department
            designation
            profileImage {
              url
              fileName
            }
            status
          }
        }
      }
      targetStatus
      createdBy {
        firstName
        fullName
        id
        lastName
        department
        designation
        profileImage {
          url
          fileName
        }
        role
        status
      }
      createdAt
      updatedAt
      readAttachment {
        read
        count
      }
    }
  }
`;

export const getTargetTemplatePreview = gql`
  query getTargetTemplatePreview($id: ID!) {
    getTarget(id: $id) {
      id
      companyId
      isNew
      title
      type
      description
      reviewStatus
      targetTag
      createdByUserId
      completionApprovalRequired
      startDate
      targetOverviewObjectives {
        objectives {
          id
          name
          objectiveSequenceNo
        }
      }
      targetOverviewCheckin {
        checkins {
          id
          name
          checkInType
          combinedCheckInTypes
          userRoleTypeForSRS
          description
          startDate
          endDate
          templateLaunchDay
          isImmediate
          daysToComplete
          checkInStatus
          updatedAt
          checkInStatus
          createdByUserId
          isCommentResponse
          isUploadResponse
          createdBy {
            firstName
            lastName
            profileImage {
              fileName
            }
          }
          allCheckinViewers {
            id
          }
          checkinCoachId
          checkinCoach {
            firstName
            lastName
            profileImage {
              fileName
            }
          }
          usercheckin {
            items {
              id
              userid
              checkInStatus
              user {
                id
                firstName
                lastName
                profileImage {
                  fileName
                }
              }
            }
          }
          allCheckinRatees {
            userid
            firstName
            lastName
            profileImage {
              fileName
            }
          }
          showDetails
        }
      }
      skillsAndStrengths {
        id
        name
        isStrength
        color
        category
      }
      logo {
        url
        fileName
      }
      unsplashImage {
        url
        fileName
      }
      targetAttachmentLinks
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      dueDate
      weightage
      coachTarget {
        items {
          id
          targetid
          coachid
          appointedAsCreator
          coach {
            id
            eeid
            firstName
            lastName
            role
            department
            designation
            profileImage {
              url
              fileName
            }
            status
          }
        }
      }
      targetStatus
      createdBy {
        firstName
        fullName
        id
        lastName
        department
        designation
        profileImage {
          url
          fileName
        }
        role
        status
      }
      createdAt
      updatedAt
    }
  }
`;

export const getTargetObjectveInfo = gql`
  query getTargetObjectveInfo($id: ID!) {
    getTarget(id: $id) {
      id
      targetOverviewObjectives {
        role
        isCoacheeCA
        objectiveTeamview
        userObjectives {
          id
          targetobjectiveid
          userid
          isNew
          isNewHighlight
          targetobjective {
            id
            name
            objectiveSequenceNo
          }
          user {
            id
            firstName
            lastName
            profileImage {
              url
              fileName
            }
            status
          }
          comment
          commentedDate
          status
          subStatus
        }
        objectives {
          id
          name
          objectiveSequenceNo
          objectiveUser {
            items {
              id
              userid
              user {
                id
                firstName
                lastName
                profileImage {
                  url
                  fileName
                }
                status
              }
              isNew
              isNewHighlight
              status
              subStatus
              comment
            }
          }
        }
      }
    }
  }
`;

export const getPeopleInfo = gql`
  query getPeopleInfo($id: ID!) {
    getTarget(id: $id) {
      targetOverviewPeople {
        isNew
        srNo
        role
        leadReviewer
        userTargetId
        user {
          id
          firstName
          lastName
          profileImage {
            fileName
          }
          status
        }
        checkinCompleted
        totalCheckin
        objectivesCompleted
        totalObjectives
        userTargetStatus
        selfRating
        leadReviewerRating
        coachRatings {
          reviewerId
          rating
        }
        topStrengths {
          sequenceNo
          strength
          color
          id
          description
        }
      }
    }
  }
`;

export const getCheckinInfo = gql`
  query getCheckinInfo($id: ID!) {
    getTarget(id: $id) {
      targetOverviewCheckin {
        targetId
        checkins {
          checkInUserRole
          id
          name
          checkInType
          combinedCheckInTypes
          userRoleTypeForSRS
          description
          startDate
          endDate
          templateLaunchDay
          isNew
          isNewHighlight
          isImmediate
          daysToComplete
          checkInStatus
          updatedAt
          checkInStatus
          createdByUserId
          isCommentResponse
          isUploadResponse
          createdBy {
            firstName
            lastName
            profileImage {
              fileName
            }
          }
          allCheckinViewers {
            id
          }
          checkinCoachId
          checkinCoach {
            firstName
            lastName
            profileImage {
              fileName
            }
          }
          linkCheckin {
            link
            title
            description
            image
          }
          multimediaCheckin {
            s3Link {
              key
              url
              fileName
            }
            fileType
            isVideoUrl
          }
          surveyCheckin {
            surveycheckin {
              questionType
              question
              options
              answer
              userAnswer
            }
            isanonymous
            score
          }
          isTestSurvey
          userCheckinDetails {
            endDate
            checkinSequenceNo
            id
            isCurrentFrequency
            startDate
            status
          }
          usercheckin {
            items {
              id
              userid
              checkInStatus
              user {
                id
                firstName
                lastName
                status
                profileImage {
                  fileName
                }
              }
            }
          }
          allCheckinRatees {
            userid
            firstName
            lastName
            profileImage {
              fileName
            }
          }
          showDetails
        }
      }
    }
  }
`;

export const getUserCheckIn = gql`
  query getUserCheckIn($id: ID!) {
    getUserCheckIn(id: $id) {
      id
      completionDate
      surveyCheckin {
        userAvgScore
        correctAns
        totalAns
        surveycheckin {
          isCorrect
          answer
          options
          question
          questionType
          userAnswer
        }
      }
    }
  }
`;

export const getTargetActivityInfo = gql`
  query getTargetActivityInfo($id: ID!) {
    getTarget(id: $id) {
      activityFeed {
        nextToken
        items {
          id
          activity
          activityMessage
          createdByUserId
          createdByUser {
            firstName
            lastName
          }
          dateTime
        }
      }
    }
  }
`;

export const getSingleCheckIn = gql`
  query getSingleCheckIn($id: ID!) {
    getCheckIn(id: $id) {
      id
      name
      description
      checkInType
      scheduleFrequency
      startDate
      endDate
      assignPeopleGroup {
        assignCoachees
        assignViewers
        primaryCoach
        assignRaters
      }
      frequencyRepeatDays
      frequencyRepeatonDate
      isWeekend
      weekDays {
        value
        name
        isSelected
      }
      frequencyRepeatMonthly {
        dayofMonth
        dayOfWeek
        dayOfWeekOccurrence
      }
      createdAt
      isCheckinLibrary
      createdBy {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
        department
        designation
        supervisor {
          id
          firstName
          lastName
        }
      }
      checkInStatus
      daysToComplete
      isCommentResponse
      isUploadResponse
      isTestSurvey
      checkInTargetId
      checkinCoachId
      templateEndDateTime
      templateLaunchDay
      templateLaunchDateTime
      launchTime
      dueTime
      isImmediate
      userCheckinDetails {
        endDate
        checkinSequenceNo
        id
        isCurrentFrequency
        startDate
        status
      }
      checkinFrequencyDates {
        startDate
        endDate
        sequenceNo
      }
      checkinCoach {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
      }
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      linkCheckin {
        link
        title
        description
        image
      }
      surveyLinks {
        link
        description
        title
        image
      }
      surveyMultimediaCheckin {
        fileType
        s3Link {
          bucket
          fileName
          key
          region
          uploadUrl
          url
          isNew
        }
        isVideoUrl
      }
      multimediaCheckin {
        fileType
        s3Link {
          bucket
          fileName
          key
          region
          uploadUrl
          url
        }
        isVideoUrl
      }
      surveyCheckin {
        isanonymous
        score
        surveycheckin {
          answer
          options
          question
          questionType
          userAnswer
        }
      }
      usersForCheckin {
        items {
          isSoftDelete
          user {
            status
            firstName
            lastName
            id
            profileImage {
              url
              fileName
            }
            department
            role
            designation
            supervisor {
              id
              fullName
              firstName
              lastName
              profileImage {
                fileName
              }
            }
          }
        }
      }
      allCheckinViewers {
        isAddedFromBE
        lastName
        firstName
        userid
        isSoftDelete
        status
        profileImage {
          key
          fileName
          url
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          profileImage {
            fileName
          }
        }
      }
      allCheckinRatees {
        firstName
        lastName
        userid
        isSoftDelete
        profileImage {
          url
          fileName
          key
        }
        department
        role
        designation
        status
        supervisor {
          id
          fullName
          firstName
          lastName
          status
          profileImage {
            fileName
          }
        }
      }
      allCheckinRaters {
        lastName
        firstName
        userid
        isSoftDelete
        status
        profileImage {
          key
          fileName
          url
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          status
          profileImage {
            fileName
          }
        }
      }
    }
  }
`;

export const CheckinFrequencyDatesList = gql`
  query checkinFrequencyDatesList(
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $frequencyRepeatDays: Int
    $isWeekend: Boolean
    $weekDays: [WeekDaysInput]
    $frequencyRepeatMonthly: FrequencyRepeatMonthlyInput
    $daysToComplete: Int
    $frequencyRepeatonDate: AWSDateTime
    $checkInTargetId: ID
    $scheduleFrequency: ScheduleFrequency
  ) {
    checkinFrequencyDatesList(
      startDate: $startDate
      endDate: $endDate
      frequencyRepeatDays: $frequencyRepeatDays
      isWeekend: $isWeekend
      weekDays: $weekDays
      frequencyRepeatMonthly: $frequencyRepeatMonthly
      daysToComplete: $daysToComplete
      frequencyRepeatonDate: $frequencyRepeatonDate
      checkInTargetId: $checkInTargetId
      scheduleFrequency: $scheduleFrequency
    ) {
      endDate
      startDate
      sequenceNo
      scheduleFrequency
      frequencyRepeatonDate
      frequencyRepeatDays
    }
  }
`;

export const getTargetTitleTagDetails = gql`
  query getTargetTitleTagDetails($id: ID!) {
    getTarget(id: $id) {
      title
      description
      type
      dueDate
      id
      createdBy {
        firstName
        lastName
        profileImage {
          fileName
        }
      }
      logo {
        fileName
      }
    }
  }
`;

export const getCheckinDetail = gql`
  query getCheckIn($id: ID!) {
    getCheckIn(id: $id) {
      id
      name
      description
      checkInType
      scheduleFrequency
      startDate
      endDate
      createdAt
      checkInStatus
      checkinCoach {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
      }
      linkCheckin {
        link
        title
        description
        image
      }
      multimediaCheckin {
        fileType
        s3Link {
          bucket
          fileName
          key
          region
          uploadUrl
          url
        }
        isVideoUrl
      }
      usersForCheckin {
        items {
          user {
            firstName
            lastName
            id
            profileImage {
              url
              fileName
            }
            department
            role
            designation
            supervisor {
              id
              fullName
              firstName
              lastName
              profileImage {
                fileName
              }
            }
          }
        }
      }
      allCheckinViewers {
        isAddedFromBE
        lastName
        firstName
        userid
        profileImage {
          key
          fileName
          url
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          profileImage {
            fileName
          }
        }
      }
      allCheckinRatees {
        firstName
        lastName
        userid
        profileImage {
          url
          fileName
          key
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          profileImage {
            fileName
          }
        }
      }
      allCheckinRaters {
        lastName
        firstName
        userid
        profileImage {
          key
          fileName
          url
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          profileImage {
            fileName
          }
        }
      }
    }
  }
`;

export const getUserListToRate = gql`
  query getUserListToRate($id: ID!, $isTargetCompletion: Boolean) {
    getTarget(id: $id) {
      id
      userListToRate(isTargetCompletion: $isTargetCompletion) {
        id
        totalCheckin
        checkinCompleted
        totalObjectives
        objectivesCompleted
        leadReviewerRating
        selfRating
        coachRatings {
          id
          comment
          rating
          ratingBeforeSubmit
          commentBeforeSubmit
        }
        user {
          id
          firstName
          lastName
          profileImage {
            fileName
            url
          }
          department
          designation
          status
        }
        userTargetStatus
        ratingSubmitted
        rating
        comment
      }
    }
  }
`;

export const getPerformanceRatings = gql`
  query getPerformanceRatings($userTargetId: ID, $targetId: ID) {
    getPerformanceRatings(userTargetId: $userTargetId, targetId: $targetId) {
      rating
      role
      date
      targetid
      completionApprovalRequired
      isNew
      commentedBy {
        id
        firstName
        lastName
        profileImage {
          url
          fileName
        }
        designation
      }
      comment
      teamSummary {
        self {
          isNew
          comment
          rating
          role
          date
          targetid
          userTargetId
          userTargetStatus
          commentedBy {
            id
            firstName
            lastName
            profileImage {
              url
              fileName
            }
            designation
            status
          }
        }
        coachRating {
          isNew
          comment
          rating
          role
          date
          targetid
          commentedBy {
            id
            firstName
            lastName
            profileImage {
              url
              fileName
            }
            designation
          }
        }
        leadReviewerRating {
          isNew
          comment
          rating
          role
          date
          targetid
          commentedBy {
            id
            firstName
            lastName
            profileImage {
              url
              fileName
            }
            designation
          }
        }
      }
    }
  }
`;
